import React, { Fragment, useState, useEffect, useRef } from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';
import { CircularProgress, Divider, FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import dayjs from 'dayjs';
import { setPaymentResponse } from '../store/dataslice';
import PayseraPayment from '../PayseraPayment';
import { FaEuroSign } from 'react-icons/fa';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const LLOJI_PAGESES_ID = 1172;
// const INSTITUCIONI_ID = 1172;
const SHERBIMI_TIPI_ID = 7;

const Dogana_PaymentFields = () => {
    const navigate = useNavigate();
    // const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [NumriSerik, setNumriSerik] = useState();
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [Loan, setLoan] = useState(false);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetInstitucionServiceData', {
                llojipagesesID: LLOJI_PAGESES_ID,
                serialNumber: NumriSerik,
                token: token
            });
            if (response && response.data && response.data.success && response.data.respond && response.data.respond.result === 'OK' && !response.data.respond.hasError) {
                setInstitucioniServiceData(response.data.respond);
                setKerkoLoading(false);
            } else {
                setKerkoLoading(false);
                setInstitucioniServiceData(null);
                const errorCode = response && response.data && response.data.respond ? response.data.respond.errorCode : null;
                let errorText = 'Pagesa me këtë numër fature nuk është gjetur!';
                if (errorCode === '3') {
                    errorText = 'Kjo faturë është paguar tashmë!';
                } else if (errorCode === '4') {
                    errorText = 'Numri i faturës është i pavlefshëm!';
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Gabim',
                    text: errorText
                });
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: 'Pagesa me këtë numër fature nuk është gjetur!'
            });
        }
    };

    async function handleSearch() {
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    const handleBack = () => {
        navigate('/');
    }

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
    });

    const formik = useFormik({
        initialValues: {
            Email: '',
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values);
        },
    });

    const [shumaValue, setShumaValue] = useState();

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.amount) {
            setShumaValue(InstitucioniServiceData.amount);
        }
    }, [InstitucioniServiceData]);

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                emri: InstitucioniServiceData.traderName && InstitucioniServiceData.traderName.trim() !== ''
                    ? InstitucioniServiceData.traderName
                    : '//',
                mbiemri: '//',
                institucioniId: 132,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: LLOJI_PAGESES_ID,
                numriSerik: NumriSerik,
                numriIdentifikues: InstitucioniServiceData.companyCode,
                numriUnikPageses: InstitucioniServiceData.kOSGiroId,
                strDataPageses: `${strDataPageses}`,
                shuma: shumaValue,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                pershkrimi: 'Pagesë për Doganën e Kosovës',
                paymentMethod: 3,
                sherbimiTipiID: SHERBIMI_TIPI_ID,
                unirefOK: false,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode
            }
            const response = await postData('Pagesat/PagesaPerSherbime', newData);
            if (response && response.status === 200) {
                setLoanLoading(false);
                setPagesaLoading(false);
                setUpdateLoader(false);
                const paymentWindow = window.open('', '_self');
                paymentWindow.location.href = `${response.data.link}`;
            }
        } catch (error) {
            setLoanLoading(false);
            setPagesaLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    // provisioni

    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=${LLOJI_PAGESES_ID}&Amount=${InstitucioniServiceData.amount}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data)
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
            }
        } catch (error) {
            // handled silently, provizioni stays null
        }
    }

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.amount !== '') {
            getProvizioni();
        }
    }, [InstitucioniServiceData]);

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes numrit të faturës <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        type="text"
                                        style={{ WebkitAppearance: 'textfield' }}
                                        id="outlined-adornment-input"
                                        placeholder="Numri i faturës"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && NumriSerik !== undefined) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || NumriSerik === undefined || NumriSerik === ''}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e pagesës doganore</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Data">Datë</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Datë"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.receiptDate}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="LlojiPageses">Lloji i pagesës</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Lloji i pagesës"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.typeOfPayment}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Statusi">Statusi</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Statusi"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.receiptStatus}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="ZyraDoganore">Zyra doganore</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Zyra doganore"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.customsOffice}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="KodiKompanise">Kodi i kompanisë</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Kodi i kompanisë"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.companyCode}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="ObliguesiDoganor">Obliguesi doganor</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Obliguesi doganor"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.traderName}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Email">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            (formik.touched.Email && formik.errors.Email) &&
                                            (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="TotaliPagueshem">Shuma për pagesë</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Shuma për pagesë"
                                        value={InstitucioniServiceData.amount}
                                        endAdornment={<FaEuroSign />}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />

                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni"> Provizioni</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='Provizioni'
                                            value={provizioni && provizioni.provizioni}
                                        />
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="ShumaTotale">Shuma Totale</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shuma Totale"
                                            endAdornment={<FaEuroSign />}
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='strVleraTotale'
                                            value={provizioni && provizioni.strtotal_pagesa}
                                        />
                                    </div>
                                </div>
                                <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayProcess}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës doganore kërkoni përmes numrit të faturës.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>

                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default Dogana_PaymentFields
